import { render, staticRenderFns } from "./DepartmentSubjectIndex.vue?vue&type=template&id=0e649f5e"
import script from "./DepartmentSubjectIndex.vue?vue&type=script&lang=js"
export * from "./DepartmentSubjectIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports